// extracted by mini-css-extract-plugin
export default {"paragraph":"P_paragraph__+r6Rl","ellipsis":"P_ellipsis__DGbah","hover":"P_hover__OhdWX"};